import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useLocation, useNavigate } from 'react-router-dom';
import "./GetGiftVoucher.css";
import PaymentProvider from '../payment/PaymentProvider';
import { useTranslation } from 'react-i18next';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const serverUrl = "/api";

const CheckoutForm = ({ name, price, gameId, mail }) => {
    const { t , i18n} = useTranslation();
    const [error, setError] = useState(null);
    const [recipientName, setRecipientName] = useState("");
    const [wish, setWish] = useState("");
    const stripe = useStripe();
    const elements = useElements();
    
    const navigate = useNavigate();

    const handlePayment = async () => {
        if (!recipientName.trim() || !wish.trim()) {
            setError(t('error_empty_fields'));
            return;
        }

        if (!stripe || !elements) {
            return;
        }

        try {
            const response = await fetch(serverUrl + '/create-payment-intent', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ amount: price }),
            });
            const { clientSecret } = await response.json();
            let token = localStorage.getItem('token');

            const billingDetails = token && token.trim() !== ""
                ? { name: token }
                : { email: mail };

            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                    billing_details: billingDetails,
                },
            });

            if (result.error) {
                setError(`Payment failed: ${result.error.message}`);
            } else {
                setError(null);
                console.log('Payment succeeded:', result.paymentIntent);
                const provider = new PaymentProvider();

                if (token || mail) {
                    const data = await provider.createGiftVoucher(token, gameId, price, mail || "", recipientName, wish, (i18n.language || 'bg').substring(0, 2));
                    console.log(data);
                    if (data) {
                        navigate('/success', { state: data, replace: true });
                    } else {
                        setError("Problem creating new voucher");
                    }
                } else {
                    setError("Problem getting token");
                }
            }
        } catch (error) {
            console.error('Error processing payment:', error);
            setError('Error processing payment');
        }
    };

    return (
        <div className="checkout-form">
            <h2>{t('gift_voucher')}</h2>
            <h2>{name}</h2>
            <p className="price">{t('price')}: {price} {t('bgn')}</p>
            <input
                type="text"
                placeholder={t('recipient_name')}
                value={recipientName}
                onChange={(e) => setRecipientName(e.target.value)}
                className="input-field"
            />
            <textarea
                placeholder={t('enter_wish')}
                value={wish}
                onChange={(e) => setWish(e.target.value)}
                className="input-field"
            />
            <CardElement className="card-element" />
            <button className="payment-button" onClick={handlePayment}>{t('buy_gift_voucher')}</button>
            {error && <p className="error">{error}</p>}
        </div>
    );
};

const GetGiftVoucher = () => {
    const { t } = useTranslation();
    const [gameData, setGameData] = useState(null);
    const location = useLocation();
    
    useEffect(() => {
        const fetchData = async () => {
            const { state } = location;
            console.log('Received data:', state);
            setGameData(state);
        };
        fetchData();
    }, [location]);

    if (!gameData) {
        return <div>{t('loading')}...</div>;
    }

    return (
        <div className="get-coupon">
            <Elements stripe={stripePromise}>
                <CheckoutForm name={gameData.name} price={gameData.price} gameId={gameData.gameId} mail={gameData.mail} />
            </Elements>
        </div>
    );
};

export default GetGiftVoucher;
